import formatDate from "./formatDate";

function isValidContent(validFrom, validUntil) {
  const format = "YYYYMMDDHHmm";
  const now = new Date();
  return validFrom
    ? formatDate(now, format) >= formatDate(validFrom, format) &&
        (!validUntil ||
          formatDate(now, format) <= formatDate(validUntil, format))
    : true;
}

export default isValidContent;
